import React from "react";
import { useState } from "react";

import { useQueryClient } from "@tanstack/react-query";
import { toastr } from "react-redux-toastr";
import { QuoteBilling } from "types/quote-billing";

import Button from "components/atoms/Button";

import { useSendQuote } from "utils/hooks/useSendQuote";

import DelaySelectionModal from "../../../modal/DelaySelectionModal";
import EmailSelectorModal from "../../../modal/EmailSelectorModal";

interface SendQuoteProps {
  quote: QuoteBilling;
}
interface SendQuoteState {
  template: string;
  delay: string;
  step: "init" | "template" | "delay";
}

export const SendQuote = ({ quote }: SendQuoteProps) => {
  const init = { template: "", delay: "", step: "init" } as const;

  const [state, setState] = useState<SendQuoteState>(init);
  const queryClient = useQueryClient();

  const sendEmail = async () => {
    await sendQuoteMutation.mutateAsync();
  };

  const chooseTemplate = (template: string) => {
    setState({
      ...state,
      step: "delay",
      template: template,
    });
  };

  const reset = () => {
    setState({
      step: "init",
      template: "",
      delay: "",
    });
  };

  const start = () => {
    setState({
      ...state,
      step: "template",
    });
  };

  const sendQuoteMutation = useSendQuote(quote, {
    onSuccess: () => {
      reset();
      queryClient.invalidateQueries({ queryKey: ["quotes", quote.customer_file] });
    },
    onError: (error) => {
      reset();
      toastr.error("L'envoi a échoué", "Vérifiez que le dossiers est en 'CR à vérifier'");
      console.error(`ERREUR DEVIS: ${error}`);
    },
  });

  return (
    <>
      <DelaySelectionModal
        handleCloseDelaySelectionModal={reset}
        isDelaySelectionModalOpen={state.step === "delay"}
        handleValidateDelay={sendEmail}
      />
      <EmailSelectorModal
        isEmailSelectorModalOpen={state.step === "template"}
        handleCloseEmailSelectorModal={reset}
        hasSpareParts={() => true}
        handleValidateEmailTemplate={chooseTemplate}
      />
      <Button onClick={start}> Envoyer </Button>
    </>
  );
};
